/**
 * Horizontal scroll + optional prev/next + dots for multi-tier free gift slides.
 * Initializes on cart-drawer-gift-selector elements that contain [data-gift-tiers-root].
 */
function initGiftTierCarousel(host) {
  if (!host) return;
  if (host.dataset.giftTierCarouselWired === 'true') {
    if (typeof host._giftTierCarouselRefresh === 'function') {
      try {
        host._giftTierCarouselRefresh();
      } catch (_) {}
    }
    return;
  }
  const root = host.querySelector('[data-gift-tiers-root]');
  const track = host.querySelector('[data-gift-tiers-track]');
  if (!root || !track) return;

  const viewport = track.parentElement;
  const slides = track.querySelectorAll('[data-gift-tier-slide]');
  if (slides.length < 2) return;

  const showArrows = root.dataset.showArrows !== 'false';
  const showDots = root.dataset.showDots !== 'false';
  const prevBtn = root.querySelector('[data-gift-tier-prev]');
  const nextBtn = root.querySelector('[data-gift-tier-next]');
  const dotsWrap = root.querySelector('[data-gift-tier-dots]');

  let dotButtons = [];

  function slideWidth() {
    return viewport.clientWidth || track.clientWidth;
  }

  function maxScroll() {
    return Math.max(0, track.scrollWidth - viewport.clientWidth);
  }

  function activeIndex() {
    const w = slideWidth();
    if (w <= 0) return 0;
    return Math.round(track.scrollLeft / w);
  }

  /**
   * Track height follows the tallest slide; the viewport was inheriting that
   * height so shorter slides showed a large empty gap under the teaser card.
   * Pin viewport height to the active slide only.
   */
  function syncViewportHeight() {
    if (host.classList.contains('gift-chooser-mode')) return;
    const idx = activeIndex();
    const slide = slides[idx];
    if (!slide || !viewport) return;
    const h = slide.getBoundingClientRect().height;
    if (h > 0) {
      viewport.style.height = `${Math.ceil(h)}px`;
    }
  }

  function scrollToIndex(i) {
    const w = slideWidth();
    track.scrollTo({ left: i * w, behavior: 'smooth' });
  }

  function updateNav() {
    const max = maxScroll();
    const left = track.scrollLeft;
    if (prevBtn) {
      prevBtn.disabled = left <= 2;
      prevBtn.setAttribute('aria-disabled', prevBtn.disabled ? 'true' : 'false');
    }
    if (nextBtn) {
      nextBtn.disabled = left >= max - 2;
      nextBtn.setAttribute('aria-disabled', nextBtn.disabled ? 'true' : 'false');
    }
    const idx = activeIndex();
    dotButtons.forEach((d, j) => {
      d.classList.toggle('is-active', j === idx);
      d.setAttribute('aria-selected', j === idx ? 'true' : 'false');
    });
    syncViewportHeight();
  }

  if (showArrows && prevBtn && nextBtn) {
    prevBtn.addEventListener('click', () => {
      const w = slideWidth();
      track.scrollBy({ left: -w, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      const w = slideWidth();
      track.scrollBy({ left: w, behavior: 'smooth' });
    });
  }

  if (showDots && dotsWrap) {
    dotsWrap.innerHTML = '';
    slides.forEach((slide, i) => {
      const label = slide.dataset.tierLabel || `Tier ${i + 1}`;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cart-drawer-gift__tier-dot';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-label', label);
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.addEventListener('click', () => scrollToIndex(i));
      dotsWrap.appendChild(btn);
      dotButtons.push(btn);
    });
  }

  track.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateNav);
  }, { passive: true });

  window.addEventListener(
    'resize',
    debounceGiftTiers(() => {
      updateNav();
    }, 150)
  );

  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(() => {
      window.requestAnimationFrame(() => {
        if (host.classList.contains('gift-chooser-mode')) return;
        syncViewportHeight();
      });
    });
    slides.forEach((s) => ro.observe(s));
  }

  host._giftTierCarouselRefresh = updateNav;
  updateNav();
  host.dataset.giftTierCarouselWired = 'true';
}

function refreshGiftTierCarousel(host) {
  if (!host) return;
  if (typeof host._giftTierCarouselRefresh === 'function') {
    try {
      host._giftTierCarouselRefresh();
    } catch (_) {}
    return;
  }
  initGiftTierCarousel(host);
}

function debounceGiftTiers(fn, ms) {
  let t;
  return function debounced() {
    clearTimeout(t);
    t = setTimeout(fn, ms);
  };
}

window.initGiftTierCarousel = initGiftTierCarousel;
window.refreshGiftTierCarousel = refreshGiftTierCarousel;

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('cart-drawer-gift-selector[data-use-carousel="true"]').forEach((el) => initGiftTierCarousel(el));
});
